/**
 * 🧩 Kunden-Sonderfunktionen — pro KONTO serverseitig freigeschaltet (users.custom_features).
 *
 * Kommt mit /premium/status (PremiumContext) und wird hier gemerkt, damit auch Nicht-React-
 * Code (printerService) synchron prüfen kann. Andere Konten bekommen den Code mit jedem
 * Update, sehen die Funktionen aber nicht.
 *
 * Bekannte Schalter:
 *  - nachnameSortierung: Etikett „Nachname groß" + Fach automatisch = Nachnamen-Buchstabe
 *    (Green Goat, Rotterdam)
 */
const KEY = 'kiosk_custom_features';
const BATCH_DISABLED_KEY = 'kiosk_batch_barcodes_disabled';

export function getCustomFeatures() {
  try {
    const obj = JSON.parse(localStorage.getItem(KEY) || '{}') || {};
    if (localStorage.getItem(BATCH_DISABLED_KEY) === '1') {
      obj.batchBarcodes = false;
    }
    return obj;
  } catch {
    return {};
  }
}

export function hasCustomFeature(name) {
  if (name === 'batchBarcodes') {
    try {
      if (localStorage.getItem(BATCH_DISABLED_KEY) === '1') return false;
    } catch { /* */ }
  }
  return !!getCustomFeatures()[name];
}

export function setCustomFeatures(obj) {
  const next = obj && typeof obj === 'object' ? { ...obj } : {};
  try {
    if (localStorage.getItem(BATCH_DISABLED_KEY) === '1') {
      next.batchBarcodes = false;
    }
    if (JSON.stringify(next) === localStorage.getItem(KEY)) return;
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* */ }
  try { window.dispatchEvent(new CustomEvent('kiosk:custom-features', { detail: next })); } catch { /* */ }
}
